import React, { useRef, useState } from 'react'
import styled from '@emotion/styled/macro'
const Color = styled('button')`
    background-color: ${({ color }) => color};
    display: block;
    outline: none;
    min-height: 2em;
`
const ColorPicker = styled('div')`
    position: relative;
    border: var(--borders-main);
    border-radius: var(--borderRadius-sm);
    min-width: 10px;
    min-height: 10px;
    button {
        border: var(--borders-main);
        outline: none;
        padding: 0.75em;
        border-radius: var(--borderRadius-sm);
        height: 100%;
        width: 100%;
    }
    input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }
`

const ColorInput = (props) => {
    return (
        <ColorPicker>
            <input
                type="color"
                color={props.value}
                onChange={(hex) => props.onChange(hex)}
            />
            <Color type="button" color={props.value} />
        </ColorPicker>
    )
}

export default ColorInput
